            
<template>  
  <div>
  	<div class="modalsave" v-show="saveConfig.capa"></div>
    <validation-observer v-slot="{ invalid }">
      <b-form  inline style="margin-bottom:15px" novalidate >
        
                  <b-form  inline style="margin-bottom:15px" novalidate>
                    <b-row style="width:100%">
                      <b-col md="12" class="">
                        <b-row class="row-inputs">
                          <sw-inputs
                            inputTabla="info_afiliacion"
                            inputCampo="id_list_tipo"
                            :md="12"
                            :lg="6">
                          </sw-inputs>
                          <sw-inputs
                            inputTabla="info_afiliacion"
                            inputCampo="id_list_subtipo"
                            :md="12"
                            :lg="6">
                          </sw-inputs>
                        </b-row>
                      </b-col>
                      <b-col md="12">
                        <h5 class="title-form">Datos Básicos</h5>
                        <b-row  class="row-inputs">
                          <sw-inputs
                            inputTabla="datos_afiliado"
                            inputCampo="id_list_documento"
                            >
                          </sw-inputs> 
                          <sw-inputs
                              inputTabla="datos_afiliado"
                              inputCampo="documento"
                            >
                          </sw-inputs>                   
                          <sw-inputs
                              inputTabla="datos_afiliado"
                              inputCampo="nacimiento"
                              :lg='6'
                              :md='6'
                            >
                          </sw-inputs>                          
                          <sw-inputs
                              inputTabla="datos_afiliado"
                              inputCampo="nombre1"
                            >       
                          </sw-inputs>                      
                          <sw-inputs
                              inputTabla="datos_afiliado"
                              inputCampo="nombre2"
                            >
                          </sw-inputs>                     
                          <sw-inputs
                              inputTabla="datos_afiliado"
                              inputCampo="apellido1"
                            >
                          </sw-inputs>                       
                          <sw-inputs
                              inputTabla="datos_afiliado"
                              inputCampo="apellido2"
                            >
                          </sw-inputs>                     
                          <sw-inputs
                              inputTabla="datos_afiliado"
                              inputCampo="direccion"
                              :lg="6"
                            >
                          </sw-inputs>                       
                          <sw-inputs
                              inputTabla="datos_afiliado"
                              inputCampo="telefonos"
                            >
                          </sw-inputs>                      
                          <sw-inputs
                              inputTabla="datos_afiliado"
                              inputCampo="ciudad"
                            >
                          </sw-inputs>                  
                          <sw-inputs
                              inputTabla="datos_afiliado"
                              inputCampo="email"
                              :lg="6"
                            >
                          </sw-inputs> 
                            <sw-inputs
                                inputTabla="datos_afiliado"
                                inputCampo="referido"
                                :md="3"
                                :lg="3"
                              >
                            </sw-inputs>        
                            <sw-inputs
                                v-if="dataForm[namePath].datos_afiliado.referido!==null"
                                inputTabla="descuentos_referido"
                                inputCampo="descuento"
                                :md="3"
                                :lg="3"
                              >
                            </sw-inputs>          
                            <sw-inputs
                                style="margin-top: 15px"
                                inputTabla="datos_afiliado"
                                inputCampo="planilla"
                                :md="3"
                                :lg="3"
                              >
                            </sw-inputs>            
                        </b-row>
                      </b-col>   
                      <b-col md="12">
                        <h5 class="title-form">Datos afiliación</h5>
                        <b-row class="row-inputs"> 
                            <sw-inputs
                              inputTabla="info_afiliacion"
                              inputCampo="id_datos_razon">
                            </sw-inputs>               
                            <sw-inputs
                              inputTabla="info_afiliacion"
                              inputCampo="ingreso"
                              @input="changeIngreso"
                              >
                            </sw-inputs> 
                            <sw-inputs
                              inputTabla="info_afiliacion"
                              inputCampo="salario"
                              >
                            </sw-inputs> 
                            <sw-inputs
                              inputTabla="info_afiliacion"
                              inputCampo="cargo"
                              >
                            </sw-inputs> 
                            <sw-inputs
                              inputTabla="info_afiliacion"
                              inputCampo="id_datos_asesor"                              
                              :lg="3">
                            </sw-inputs>  
                            <sw-inputs
                              inputTabla="info_afiliacion"
                              inputCampo="id_datos_contacto"                              
                              :lg="3">
                            </sw-inputs>    
                            <sw-inputs
                              inputTabla="info_afiliacion"
                              inputCampo="exonerado"
                              :lg="6">
                            </sw-inputs> 
                        </b-row>
                      </b-col>                                                       
                    </b-row>                  
                  </b-form> 
      </b-form>
      <footer  id="modal-1___BV_modal_footer_" class="modal-footer" style="margin: 0 -15px; padding: 0">
              <b-row style="width:100%">
                <b-col :md="12" :lg="12" v-if="errorsAportes!=='' && errorsAportes!==null">
                    <p  class="text-danger">* {{errorsAportes}}</p>  
                </b-col>
                <b-col>     
                  <sw-saveform
                    :index="dataIndex[namePath]"
                    nameBtn=""
                    :invalid="invalidNovedad(invalid) || invalid"
                    @save="save"
                    >
                  </sw-saveform>
                </b-col>
              </b-row>
      </footer>
    </validation-observer>
  </div> 
</template>
<script>
import { mapState } from "vuex"
import { ValidationObserver } from 'vee-validate'
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform from '@/components/forms/saveForm.vue'
import moment from 'moment'
export default 
{
  name: 'swmodalasesores',
  components: {
    SwInputs,
    ValidationObserver,
    SwSaveform,      
  },
  props: {
  },
  data()
  {
    return {
      createdCycle: false,
      errorsAportes: null,
      ultimoDocumento: null
    }
  },
  destroyed()
  {    
		this.updateDatadb({state: 'info_afiliacion/ingreso/validate', data: 'required'})
  },
  async created(){
		await this.updateDatadb({state: 'info_afiliacion/ingreso/validate', data: 'required|minIngreso'})
    if(this.dataIndex[this.namePath]!==false)
    {
      this.ultimoDocumento=this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].datos_afiliado.documento

      if(typeof this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].datos_afiliado.referido !== 'object' )
      {
        this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].datos_afiliado.referido=JSON.parse(this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].datos_afiliado.referido)
      }
            
      await this.updateDataForm({state: 'datos_afiliado', data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].datos_afiliado})
      await this.updateDataForm({state: 'info_afiliacion', data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].info_afiliacion})
      await this.updateDataForm({state: 'servicios_activos', data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].servicios_activos})
      
      if(this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].descuentos_referido!==null)
      {
         await this.updateDataForm({state: 'descuentos_referido', data: this.dataGet[this.namePath].data[this.dataIndex[this.namePath]].descuentos_referido})
      }  

    }
    await this.updateGlobal({state:'openModal/modal/loaded',data:true})
  },
  computed: { 
  },
  methods: {
		invalidNovedad(invalid)
		{	
			try {
				if(invalid)
				{
					this.errorsAportes='Los campos en rojo son obligatorios.'
					return true
				}
					
				let ninguno= ''
				for(let i=0;i<this.lists.datos_afiliado.length;i++)
				{
					if(this.lists.datos_afiliado[i].documento.toString()===this.dataForm[this.namePath].datos_afiliado.documento.toString() && this.lists.datos_afiliado[i].id_list_estado===1 && this.ultimoDocumento!==this.dataForm[this.namePath].datos_afiliado.documento)
					{			
						ninguno=ninguno+' El documento '+this.dataForm[this.namePath].datos_afiliado.documento+' pertenece al afiliado '+this.dataForm[this.namePath].datos_afiliado.name+'.'	
						i=10000							
					}   
				}
				if(ninguno!=='')
				{
					this.errorsAportes=ninguno
					return true
				}	

		
				let fechaHoy=this.fecha().fecha.minHoy
				let mesActual=parseInt(moment(fechaHoy).format('MM'))
				let anoActual=parseInt(moment(fechaHoy).format('YYYY'))


				let mesIngreso=parseInt(moment(this.dataForm[this.namePath].info_afiliacion.ingreso).format('MM'))
				let anoIngreso=parseInt(moment(this.dataForm[this.namePath].info_afiliacion.ingreso).format('YYYY'))
				

				if(mesActual!=mesIngreso || anoActual!=anoIngreso)
				{
					this.errorsAportes='El inicio de labores es direfente al mes actual'
					return false
				}
				
				this.errorsAportes=null
				return false
			}catch(e)
			{
				console.log(e)
			}
    },
    changeIngreso()
		{
			let dias= moment(this.dataForm[this.namePath].info_afiliacion.ingreso).format('DD')
			if(dias>30)
			{
				dias=30
			}
			dias=31-dias
			this.updateDataForm({state: 'info_afiliacion/dias', data: dias})
			this.updateDataForm({state: 'info_afiliacion/mes_periodo', data: this.fecha(this.dataForm[this.namePath].info_afiliacion.ingreso).proximoPago.mes})
      this.updateDataForm({state: 'info_afiliacion/ano_periodo', data: this.fecha(this.dataForm[this.namePath].info_afiliacion.ingreso).proximoPago.ano})
      
			this.updateDataForm({state: 'servicios_activos/0/ano_periodo', data: this.fecha(this.dataForm[this.namePath].info_afiliacion.ingreso).proximoPago.ano})
			this.updateDataForm({state: 'servicios_activos/0/mes_periodo', data: this.fecha(this.dataForm[this.namePath].info_afiliacion.ingreso).proximoPago.mes})
		},
    save(event)
    {
      try 
      {
        this.$emit('save',{save:event.save, ftn: 'editarFichaFtn' })
      }catch(e)
      {

      }
    }
  }
}
</script>
<style>
</style>